/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteCompanyResponse
 */
export interface DeleteCompanyResponse {
  /**
   *
   * @type {boolean}
   * @memberof DeleteCompanyResponse
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof DeleteCompanyResponse
   */
  errormsg?: string | null;
}

/**
 * Check if a given object implements the DeleteCompanyResponse interface.
 */
export function instanceOfDeleteCompanyResponse(
  value: object,
): value is DeleteCompanyResponse {
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function DeleteCompanyResponseFromJSON(
  json: any,
): DeleteCompanyResponse {
  return DeleteCompanyResponseFromJSONTyped(json, false);
}

export function DeleteCompanyResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteCompanyResponse {
  if (json == null) {
    return json;
  }
  return {
    success: json["success"],
    errormsg: json["errormsg"] == null ? undefined : json["errormsg"],
  };
}

export function DeleteCompanyResponseToJSON(json: any): DeleteCompanyResponse {
  return DeleteCompanyResponseToJSONTyped(json, false);
}

export function DeleteCompanyResponseToJSONTyped(
  value?: DeleteCompanyResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    success: value["success"],
    errormsg: value["errormsg"],
  };
}
